var rgx = /(\d+)(\d{3})/

export default function toCurrency (num) {

  // round to the penny
  var s = String(num)
  var parts = s.split('.', 2)

  // add cents if there were none
  if(parts.length === 1){
    parts.push('00')
  }

  // if we have more than 2 decimal places we need to round
  // we are doing this instead of using (Math.round(num * 100) / 100) due to issues with float math
  // if the 3rd digit is greater than 5 we need to round up.
  // if we end up with 3 digits after rounding we need to add 1 to the full dollar amount
  if(parts[1].length > 2)
  {
    var subPart = parts[1].substr(0,2)
    var subPart2 = parts[1].substr(2,1)

    // if 3rd number is greater than 4 we need to round up the cents
    if(parseInt(subPart2, 10) > 4) subPart = (parseInt(subPart, 10) + 1).toString()

    // if cents is now 100 we need to add to the dollar amount and zero out the cents
    if(subPart.length > 2) {
      parts[0] = (parseInt(parts[0],10) + 1).toString()
      subPart = "00"
    }

    // pad if length isn't 2 ex. cents is 1 we want 01
    if(subPart.length < 2) subPart = "0" + subPart

    parts[1] = subPart
  }

  // pad out the pennies if needed
  while(parts[1].length < 2){
    parts[1] += "0"
  }

  // add in commas
  while (rgx.test(parts[0])) {
    parts[0] = parts[0].replace(rgx, '$1,$2')
  }

  return '$' + parts.join('.')
}
